module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content component-docs"
  }, [_c('div', {
    staticClass: "usage-content"
  }, [_c('section', {
    staticClass: "component-description"
  }, [_c('h2', {
    staticClass: "md-headline"
  }, [_vm._v("Description")]), _vm._v(" "), _vm._t("description")], 2), _vm._v(" "), (_vm.$slots.api) ? _c('section', {
    staticClass: "api-documentation"
  }, [_c('h2', {
    staticClass: "md-headline"
  }, [_vm._v("API Options")]), _vm._v(" "), _vm._t("api")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "example-content"
  }, [_vm._t("example")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06b637fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocsComponent.vue
// module id = 516
// module chunks = 83